import config from '~/config';

export default class PriceOriginComputed {
	basedOnPriceType: string;

	calculationType: string;

	constructor(basedOnPriceType: string, calculationType: string) {
		this.basedOnPriceType = basedOnPriceType;
		this.calculationType = calculationType;
	}

	humanCondensedFormatBasedOnType(): string {
		const type = config.product.priceTypes.find((type) => type.code === this.basedOnPriceType);
		return type !== undefined ? type.condensedLabel : this.basedOnPriceType;
	}
}
